<app-modal-refactor
  [size]="sizeModal || 'lg'"
  [showImage]="!!image"
  [image]="image"
  [isVerPass]="isVerPass"
  [imageClose]="'../../../assets/images/Close_modal.svg'"
  [showImageClose]="showClose"
>
  <div body class="containerError" [ngClass]="{ 'short-padding': shortPadding }">
    <!-- b5347f1a-0735-4b91-b6bc-ee8f7bba1bd1 -->
    <span *ngIf="codeError || uuidError" class="errorNumber"
      >{{ 'errorMsj.world' | translate }} {{ uuidError | shortUUID }}</span
    >
    <span class="tittleError" [ngStyle]="{ 'font-weight': fontWeightTitleError }">{{
      titleError | translate
    }}</span>
    <span
      class="fs-28px descError"
      style="margin-bottom: 0"
      [innerText]="msgError | translate"
    ></span>
    <div class="errorsBtnsPnr">
      <button
        *ngIf="showCancelButton"
        type="button"
        class="error-btn cancel"
        (click)="actionBtnCancel()"
      >
        <span>{{ cancelButtonText | translate }}</span>
      </button>
      <button
        *ngIf="showButton"
        type="button"
        class="error-btn {{ backGroundButton }} {{ colorFontButton }}"
        (click)="actionBtn()"
      >
        <img *ngIf="showIconImage" class="error-btn-img" [ngClass]="btnImgClass" [src]="urlIconImage" alt="Reload" />
        <span>{{ buttonCopy | translate }}</span>
      </button>
    </div>
    <div>
      <span class="errorNumberDescrip">{{ codeError }} </span>
    </div>
  </div>
</app-modal-refactor>
